import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';
import { obtenerCotizaciones, eliminarCotizacion, cambiarEstadoCotizacion, obtenerCotizacionCompleta } from '../services/cotizacionesService';
import { ESTADOS_COTIZACION, estadoInfo, urlCotizacionPublica } from '../utils/cotizaciones';
import { formatoMoneda } from '../utils/servicios';
import { copiarTexto } from '../utils/compartir';
import CotizacionForm from './CotizacionForm';
import ConvertirCotizacionModal from './ConvertirCotizacionModal';
import ReportesCotizacionesView from './ReportesCotizacionesView';
import OrdenForm from './OrdenForm';
import CitaForm from './CitaForm';

const P = 'var(--color-primario,#DB2777)';

export default function CotizacionesView({ onVolver }) {
  const { negocio } = useAuth();
  const { mostrarToast } = useToast();
  const { puede } = useAuth();
  const esVendedora = !puede('borrar'); // sin permiso "Borrar registros" (también lo bloquea la BD)
  const moneda = negocio?.moneda || 'L';
  const [cotizaciones, setCotizaciones] = useState(null);
  const [error, setError] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState('');
  const [form, setForm] = useState(null); // null | { cotizacion? }
  const [convertir, setConvertir] = useState(null); // cotización a convertir en venta
  const [tab, setTab] = useState('lista'); // 'lista' | 'reportes'
  const [plantilla, setPlantilla] = useState(null); // { tipo:'orden'|'cita', inicial } para crear desde la cotización

  // Crea una orden o cita precargando cliente + servicio de la cotización.
  const crearDesde = async (c, tipo) => {
    try {
      const full = await obtenerCotizacionCompleta(c.id);
      const it = (full?.items || []).find((x) => x.tipo === 'servicio' && x.servicio_id);
      setPlantilla({
        tipo,
        inicial: {
          cliente_id: c.cliente_id || null,
          cliente_nombre: c.cliente_nombre || null,
          servicio_id: it?.servicio_id || null,
          servicio_nombre: it?.descripcion || null,
          cotizacion_id: c.id,
        },
      });
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const cargar = async () => {
    setError(null);
    try { setCotizaciones(await obtenerCotizaciones()); }
    catch (e) { setError(mensajeAmigable(e)); }
  };
  useEffect(() => { cargar(); }, []);

  const cambiarEstado = async (c, estado) => {
    try {
      await cambiarEstadoCotizacion(c.id, estado);
      setCotizaciones((prev) => prev.map((x) => x.id === c.id ? { ...x, estado } : x));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  // Comparte el enlace público. Si está en borrador, la pasa a "enviada" para
  // que el cliente pueda aprobar/rechazar desde el enlace.
  const compartir = async (c) => {
    try {
      if (c.estado === 'borrador') {
        await cambiarEstadoCotizacion(c.id, 'enviada');
        setCotizaciones((prev) => prev.map((x) => x.id === c.id ? { ...x, estado: 'enviada' } : x));
      }
      const url = urlCotizacionPublica(c.codigo_publico || c.token_publico);
      const ok = await copiarTexto(url);
      mostrarToast(ok ? '🔗 Enlace copiado. Pégalo en WhatsApp para enviarlo.' : url, ok ? 'exito' : 'info');
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const borrar = async (c) => {
    if (!window.confirm(`¿Eliminar la cotización ${c.numero || ''}? No se puede deshacer.`)) return;
    try {
      await eliminarCotizacion(c.id);
      mostrarToast('Cotización eliminada 🗑️', 'exito');
      setCotizaciones((prev) => prev.filter((x) => x.id !== c.id));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const fmt = (n) => formatoMoneda(n, moneda);
  const lista = (cotizaciones || []).filter((c) => !filtroEstado || c.estado === filtroEstado);
  const fecha = (f) => f ? new Date(f + 'T00:00:00').toLocaleDateString('es-HN', { day: '2-digit', month: 'short', year: 'numeric' }) : '';

  return (
    <div className="k-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 className="k-page-title">🧾 Cotizaciones</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setTab(tab === 'reportes' ? 'lista' : 'reportes')}
            style={{ padding: '10px 16px', background: tab === 'reportes' ? P : '#fff', color: tab === 'reportes' ? '#fff' : P, border: `1px solid ${P}`, borderRadius: '8px', fontWeight: 700, cursor: 'pointer' }}>
            📊 Reportes
          </button>
          {tab === 'lista' && <button onClick={() => setForm({})} style={{ padding: '10px 18px', background: P, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nueva cotización</button>}
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>

      {tab === 'reportes' && <ReportesCotizacionesView />}

      {tab === 'lista' && cotizaciones && cotizaciones.length > 0 && (
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <button onClick={() => setFiltroEstado('')} style={chip(filtroEstado === '')}>Todas</button>
          {ESTADOS_COTIZACION.map((e) => (
            <button key={e.clave} onClick={() => setFiltroEstado(e.clave)} style={chip(filtroEstado === e.clave)}>{e.nombre}</button>
          ))}
        </div>
      )}

      {tab === 'lista' && !cotizaciones && !error && <div style={{ textAlign: 'center', padding: '32px', color: '#6B7280' }}>⏳ Cargando…</div>}
      {tab === 'lista' && error && <p style={{ textAlign: 'center', padding: '24px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
      {tab === 'lista' && cotizaciones && cotizaciones.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 16px', color: '#6B7280' }}>
          <div style={{ fontSize: '46px' }}>🧾</div>
          <p style={{ fontWeight: 700, color: '#111827', margin: '8px 0 4px' }}>Aún no tienes cotizaciones</p>
          <p style={{ fontSize: '14px', margin: '0 0 16px' }}>Crea una cotización con tus servicios y productos para enviarla a un cliente.</p>
          <button onClick={() => setForm({})} style={{ padding: '12px 22px', background: P, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Crear mi primera cotización</button>
        </div>
      )}

      {tab === 'lista' && lista.length > 0 && (
        <div style={{ display: 'grid', gap: '10px' }}>
          {lista.map((c) => {
            const est = estadoInfo(c.estado);
            return (
              <div key={c.id} className="k-card" style={{ padding: '14px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <strong style={{ color: '#111827' }}>{c.numero || 'Cotización'}</strong>
                    <span style={{ fontSize: '11.5px', fontWeight: 700, color: est.color, background: est.bg, padding: '2px 9px', borderRadius: '999px' }}>{est.nombre}</span>
                  </div>
                  <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6B7280' }}>
                    {c.cliente_nombre || 'Sin cliente'}{c.fecha_emision ? ` · ${fecha(c.fecha_emision)}` : ''}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ margin: 0, fontWeight: 800, color: P, fontSize: '16px' }}>{fmt(c.total)}</p>
                  {Number(c.saldo) > 0 && Number(c.saldo) !== Number(c.total) && (
                    <p style={{ margin: 0, fontSize: '11.5px', color: '#9CA3AF' }}>Saldo: {fmt(c.saldo)}</p>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', width: '100%', justifyContent: 'flex-end', borderTop: '1px solid #F3F4F6', paddingTop: '8px' }}>
                  <select value={c.estado} onChange={(e) => cambiarEstado(c, e.target.value)}
                    style={{ padding: '5px 8px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '12px', background: '#fff' }}>
                    {ESTADOS_COTIZACION.map((e) => <option key={e.clave} value={e.clave}>{e.nombre}</option>)}
                  </select>
                  {c.estado === 'aprobada' && (
                    <button onClick={() => setConvertir(c)} style={{ padding: '5px 12px', background: '#059669', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>💰 Convertir en venta</button>
                  )}
                  {(c.estado === 'aprobada' || c.estado === 'convertida') && (
                    <>
                      <button onClick={() => crearDesde(c, 'orden')} style={{ padding: '5px 10px', background: '#F3F4F6', color: '#374151', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>📋 Orden</button>
                      <button onClick={() => crearDesde(c, 'cita')} style={{ padding: '5px 10px', background: '#F3F4F6', color: '#374151', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>📅 Cita</button>
                    </>
                  )}
                  <button onClick={() => compartir(c)} style={{ padding: '5px 12px', background: 'color-mix(in srgb, var(--color-primario,#DB2777) 12%, white)', color: P, border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>🔗 Compartir</button>
                  <button onClick={() => setForm({ cotizacion: c })} style={{ padding: '5px 12px', background: '#EEF2FF', color: '#4338CA', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>✏️ Abrir</button>
                  {!esVendedora && <button onClick={() => borrar(c)} style={{ padding: '5px 10px', background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', fontSize: '12px', color: '#DC2626', cursor: 'pointer' }}>🗑️</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {form && (
        <CotizacionForm
          cotizacion={form.cotizacion || null}
          onCerrar={() => setForm(null)}
          onGuardado={cargar}
        />
      )}

      {convertir && (
        <ConvertirCotizacionModal
          cotizacion={convertir}
          onCerrar={() => setConvertir(null)}
          onConvertida={cargar}
        />
      )}

      {plantilla?.tipo === 'orden' && (
        <OrdenForm inicial={plantilla.inicial} onCerrar={() => setPlantilla(null)} onGuardado={() => setPlantilla(null)} />
      )}
      {plantilla?.tipo === 'cita' && (
        <CitaForm inicial={plantilla.inicial} onCerrar={() => setPlantilla(null)} onGuardado={() => setPlantilla(null)} />
      )}
    </div>
  );
}

function chip(activo) {
  return {
    padding: '5px 12px', borderRadius: '999px', fontSize: '12.5px', fontWeight: 600, cursor: 'pointer',
    border: activo ? `1px solid ${P}` : '1px solid #E5E7EB',
    background: activo ? 'color-mix(in srgb, var(--color-primario,#DB2777) 10%, white)' : '#fff',
    color: activo ? P : '#6B7280',
  };
}
